import { inject, injectable } from 'inversify'
import type { INativeNotification } from '@/services/types'
import type LoggerService from '@/services/loggerService'
import { SERVICE_TYPES } from '@/core/container/types'
import LogoImageUrl from '@/assets/images/logo.png'

@injectable()
export default class NativeNotificationService implements INativeNotification {
  constructor(@inject(SERVICE_TYPES.LoggerService) protected readonly loggerService: LoggerService) {}

  public isHasNotificationFeature(): boolean {
    return Boolean('Notification' in window)
  }

  public isNotificationDenied() {
    return this.isHasNotificationFeature() && Notification.permission === 'denied'
  }

  public isNotificationGranted() {
    return this.isHasNotificationFeature() && Notification.permission === 'granted'
  }

  public isAllowNotificationRequest() {
    return this.isHasNotificationFeature() && Notification.permission === 'default'
  }

  public notificationRequest(callback?: (result: string) => void) {
    if (this.isAllowNotificationRequest()) {
      Notification.requestPermission(callback)
    }
  }

  public notify(tag: string, title: string, text: string, icon?: string, onClickCallback?: () => void) {
    if (!this.isNotificationGranted()) {
      return
    }
    icon = icon || LogoImageUrl
    const notification = new Notification(title, {
      icon,
      tag,
      body: text,
    })
    if (onClickCallback) {
      notification.onclick = () => {
        try {
          onClickCallback()
        } catch (e) {
          this.loggerService.error('error', (e as Error).message)
        }
        window.focus()
        notification.close()
      }
    }
  }
}
